import config from 'config';

const LOAD = 'common/article/LOAD';
const LOAD_SUCCESS = 'common/article/LOAD_SUCCESS';
const LOAD_FAIL = 'common/article/LOAD_FAIL';

const LOAD_EVENT_STORY = 'common/article/LOAD_EVENT_STORY';
const LOAD_SUCCESS_EVENT_STORY = 'common/article/LOAD_SUCCESS_EVENT_STORY';
const LOAD_FAIL_EVENT_STORY = 'common/article/LOAD_FAIL_EVENT_STORY';

const initialState = {
  articleIdRefs: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.articleId]: {
          ...state[action.articleId],
          loading: true
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [action.articleId]: {
          ...state[action.articleId],
          loading: false,
          loaded: true,
          error: null,
          article: action.result
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.articleId]: {
          ...state[action.articleId],
          loading: false,
          loaded: false,
          error: action.error
        }
      };

    // The cases below are for when an article is retreived by an event id and story type.
    // It is to remove duplication of data in the case that an article is both in a basket
    // and an article for a particular event.
    case LOAD_EVENT_STORY: {
      const ref = lookupRef(action.eventId, action.storyType);
      return {
        ...state,
        // This keeps a dictionary of references to a list of article IDs for lookups.
        articleIdRefs: {
          ...state.articleIdRefs,
          [ref]: {
            ...state.articleIdRefs[ref],
            loading: true
          }
        }
      }
    }
    case LOAD_SUCCESS_EVENT_STORY: {
      const ref = lookupRef(action.eventId, action.storyType);
      const articleList = action.result.articles;
      const idFor = article => article.article_reference.id;

      // Convert the articles retreived via the event id and story type to an object keyed
      // by its article reference ID. This can then be appended to the correct object using
      // object rest spread operator.
      const articles = articleList.reduce((prev, currArticle) => {
        const articleId = idFor(currArticle);
        prev[articleId] = {
          ...state[articleId],
          loading: false,
          loaded: true,
          error: null,
          article: currArticle
        };
        return prev;
      }, {});

      return {
        ...state,
        articleIdRefs: {
          ...state.articleIdRefs,
          [ref]: {
            ...state.articleIdRefs[ref],
            articleIds: articleList.map(idFor),
            loading: false,
            loaded: true,
            error: null
          }
        },
        ...articles
      };
    }
    case LOAD_FAIL_EVENT_STORY: {
      const ref = lookupRef(action.eventId, action.storyType);
      return {
        ...state,
        articleIdRefs: {
          ...state.articleIdRefs,
          [ref]: {
            ...state.articleIdRefs[ref],
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      }
    }
    default:
      return state;
  }
}

export function lookupRef(eventId, storyType) {
  return eventId + "-" + storyType;
}

export function isLoadingByEventIdStoryType(globalState, eventId, storyType) {
  const ref = lookupRef(eventId, storyType);

  if (!globalState.common.article.articleIdRefs[ref] ||
      !globalState.common.article.articleIdRefs[ref].loaded) {
    return false;
  }

  const articleIds = globalState.common.article.articleIdRefs[ref]
                  && globalState.common.article.articleIdRefs[ref].articleIds;

  let articlesLoaded = true;
  for(let i=0; i<articleIds.length; i++) {
    if (!isLoadingByArticleId(globalState, articleIds[i])) {
      articlesLoaded = false;
    }
  }
  return articlesLoaded;
}

export function isLoadingByArticleId(globalState, articleId) {
  return globalState.common.article
      && globalState.common.article[articleId]
      && globalState.common.article[articleId].loading;
}

export function loadByArticleId(globalState, articleId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.common.loadArticle}/${articleId}`),
    articleId
  };
}

export function loadByEventIdStoryType(globalState, eventId, storyType) {
  return {
    types: [LOAD_EVENT_STORY, LOAD_SUCCESS_EVENT_STORY, LOAD_FAIL_EVENT_STORY],
    promise: (client) => client.get(`${config.api.common.loadArticle}?eventId=${eventId}&storyType=${storyType}`),
    eventId,
    storyType
  };
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/article.js